@if (task) {
  <div class="task" [id]="'activity_' + task.id">
    <div class="task-header">
      <div class="task-evaluation-status">
        @if (task.evaluationStatus === 'undecided') {
          <fa-icon class="undecided" [icon]="faQuestionCircle" size="2x" pTooltip="Undecided"></fa-icon>
        }
        @if (task.evaluationStatus === 'passed') {
          <fa-icon class="passed" [icon]="faThumbsUp" size="2x" pTooltip="Passed"></fa-icon>
        }
        @if (task.evaluationStatus === 'failed') {
          <fa-icon class="failed" [icon]="faThumbsDown" size="2x" pTooltip="Failed"></fa-icon>
        }
        @if (task.evaluationStatus === 'notapplicable') {
          <fa-icon class="not-applicable" [icon]="faBan" size="2x" pTooltip="Not applicable"></fa-icon>
        }
      </div>
      <div class="task-execution-status">
        @if (task.executionStatus === 'notstarted') {
          <fa-icon class="undecided" [icon]="faTasks" size="2x" pTooltip="Not started"></fa-icon>
        }
        @if (task.executionStatus === 'inprogress') {
          <fa-icon class="inprogress" [icon]="faRunning" size="2x" pTooltip="In progress"></fa-icon>
        }
        @if (task.executionStatus === 'waitingforreview') {
          <fa-icon class="waitingforreview" [icon]="faHourglass" size="2x" pTooltip="Waiting for review"></fa-icon>
        }
        @if (task.executionStatus === 'finished') {
          <fa-icon class="finished" [icon]="faFlagCheckered" size="2x" pTooltip="Finished"></fa-icon>
        }
        @if (task.executionStatus === 'skipped') {
          <fa-icon class="skipped" [icon]="faForward" size="2x" pTooltip="Skipped"></fa-icon>
        }
        @if (task.executionStatus === 'blocked') {
          <fa-icon class="blocked" [icon]="faHandPaper" size="2x" pTooltip="Blocked"></fa-icon>
        }
      </div>
      <div class="task-info">
        <div class="task-spec" [pTooltip]="task.id">{{ !(this.auditInfo.specs) || this.auditInfo.specs[task.assessedSpec]?.displayId || "not found" }} {{ this.auditInfo.specs && this.auditInfo.specs[task.assessedSpec]?.title || "not found" }}</div>
        <div class="task-object">
          <fa-icon [icon]="faGlobe"></fa-icon>
          {{ getActiveTaskTargetName() | truncate: 50 }}
        </div>
      </div>
    </div>
    <div class="task-details">
      <div class="task-actions">
        <div class="action-bar">
          <button pButton class="goto" type="button" (click)="openTestObject(task.testObjectId)" [pTooltip]="isOpenAuditDisabled() ? 'No URL to open' : null" [disabled]=isOpenAuditDisabled()>
            <fa-icon [icon]="faTv"></fa-icon>
            Open Page
          </button>
          <div class="status">
            <span>Execution Status</span>
            <p-select appendTo="body" [options]="executionStatusArray" (onChange)="setAssessmentTaskExecutionStatus($event.value)" [ngModel]="currentExecutionStatus" [showClear]="false" [filter]="false"
                      [styleClass]="'execution-status-dropdown'">
              <ng-template let-item pTemplate="item">
                <div class="audit-activity-execution-status-item">
                  <div class="label">{{ item.label }}</div>
                </div>
              </ng-template>
              <ng-template let-item pTemplate="selectedItem">
                <div class="audit-activity-execution-status-item selected-item">
                  <div class="label">{{ item.label }}</div>
                </div>
              </ng-template>
            </p-select>
          </div>
          <div class="status">
            <span>Evaluation Status</span>
            <p-select appendTo="body" [options]="evaluationStatusArray" (onChange)="setAssessmentTaskEvaluationStatus($event.value)" [ngModel]="currentEvaluationStatus" [showClear]="false" [filter]="false"
                      [styleClass]="'evaluation-status-dropdown'">
              <ng-template let-item pTemplate="item">
                <div class="audit-activity-evaluation-status-item">
                  <div class="label">{{ item.label }}</div>
                </div>
              </ng-template>
              <ng-template let-item pTemplate="selectedItem">
                <div class="audit-activity-evaluation-status-item selected-item">
                  <div class="label">{{ item.label }}</div>
                </div>
              </ng-template>
            </p-select>
          </div>
        </div>
        <wm-editable-text tabindex="0" [placeholder]="'Add a summary...'" [content]="task.summary" (onTextChange)="setAssessmentTaskSummary($event)"></wm-editable-text>
      </div>
      <div class="task-details-tab">
        <p-tabs [(value)]="tabViewIndex">
          <p-tablist>
            <p-tab [value]="0">Requirement</p-tab>
            <p-tab [value]="1">Findings</p-tab>
            <p-tab [value]="2">Spec</p-tab>
          </p-tablist>
          <p-tabpanels>

            <p-tabpanel [value]="0">
              <div class="task-requirement" [innerHTML]="this.auditInfo.specs![task.assessedSpec]?.description"></div>
            </p-tabpanel>
            <p-tabpanel [value]="1">
                @if ((findingsForActiveActivity || []); as findings) {
                  @for (finding of findings; track finding; let idx = $index) {
                    <div class="finding-container">
                      <wm-finding-finding [availableSpecs]="availableSpecs" [findingId]="finding" [findingCollapsed]="false"></wm-finding-finding>
                    </div>
                  }
                  @if (!findings || findings.length === 0) {
                    <div class="no-findings">No findings</div>
                  }
                } @else {
                  <div class="loading">
                    <fa-icon [icon]="faSyncAlt" animation="spin"></fa-icon>
                  </div>
                }
                <div class="add-finding">
                  <wm-add-finding-button
                      [projectId]="projectId"
                      findingType="Generic.Finding"
                      [audit]="auditId"
                      [affectedSpecs]="task ? [task.assessedSpec] : []"
                      [observationTargets]="activeFindingTargets"
                      [existingFindingsCount]="findingsForActiveActivity.length"
                      (findingCreated)="onFindingCreated($event)">
                  </wm-add-finding-button>
                </div>
            </p-tabpanel>
            <p-tabpanel [value]="2">
              <p>Tags of Spec:</p>
              <wm-tags [onlyread]="true" [onlyLocal]="true" [tags]="specLabels" class="tag-list"></wm-tags>
            </p-tabpanel>
          </p-tabpanels>
        </p-tabs>
      </div>
    </div>
  </div>
}
